jQuery(function($) {

  initMobileMenu();

  function initMobileMenu() {
    //Toggle's initial state must be toggle-closed
    $('.toggle-hidden-menu').on('click', function() {
        if(!$(this).hasClass('toggle-opened')) {
          $main_menu = $($('.fbyf-navbar')[0]);
          menu_height = $main_menu.offset().top + $main_menu.height();
          $(this).addClass('toggle-opened').removeClass('toggle-closed');
          $('.hidden-menu').css('top', menu_height);
          $('.burger').toggleClass('burger-x');
          $('body, html').addClass('body-is-mobile');
          $('.hidden-menu.closed').addClass('opened').removeClass('closed');
        }
        else {
          $(this).addClass('toggle-closed').removeClass('toggle-opened');
          $('body, html').removeClass('body-is-mobile');
          $('.burger').toggleClass('burger-x');
          $('.hidden-menu.opened').addClass('closed').removeClass('opened');
        }
    });

    $('.hidden-menu .menu-item-has-children .fl-menu-toggle').on('click', function (e) {
        $this = $(this);
        $submenu = $this.parent().siblings('.sub-menu');
        if(!$this.hasClass('toggle-opened')){
          $this.addClass('toggle-opened').removeClass('toggle-closed');
          scrollHeight = $submenu[0].scrollHeight;
          $submenu.css( "max-height", scrollHeight );

        } else {
          $this.addClass('toggle-closed').removeClass('toggle-opened');
          $submenu.css( "max-height", "0" );
          console.log('submenu closed');
        }
    });
  }

});

jQuery(function($) {
  var selectors = {
  	mobileMenu 			: '.js-mobile-menu',
  	mobileMenuToggle 	: '.js-menu-toggle',
  	pageOverlay			: '.js-page-overlay',
  	stickyHeader		: '.js-sticky-header',
  	openWinRegistration: '.js-show-win-reg'
  };

  var classes = {
  	menuToggleCollapsed	: 'menu-toggle--collapsed',
  	mobileMenuVisible	: 'mobile-menu--visible',
  	pageOverlayVisible	: 'page-overlay--visible',
  	stickyHeaderMenuOpen: 'sticky-header--menu-open',
  	stickyHeaderStuck	: 'sticky-header--stuck'
  };

  initRegistrationLink();
  initRegistrationForm();
  initExpandable();

  function initExpandable() {
    $('.expandable-row').each(function (i, elem) {
      var $container = $(elem);
      var $expandButton = $container.find('.expandable-button');
      var $expandContent = $container.find('.expandable-content');

      if (!$expandButton[0] || !$expandContent[0]) {
        return;
      }

      $expandButton.click(function () {
        $expandContent.slideToggle();
        $expandButton.toggleClass('expanded');
      });
    });
  }

  function initRegistrationForm() {
    $('.js-button-form-show a, a.js-button-form-show, .secondary-action a' ).click( function(e) {
      e.preventDefault();
      $('#js-form-modal').addClass('form-modal_show');
      $('body').addClass('noscroll');
    });

    if (window.location.hash == "#register") {
      $('#js-form-modal').addClass('form-modal_show');
      $('body').addClass('noscroll');
    }

    window.addEventListener('WinReg:Destroy', function()
      {
        $('#js-form-modal').removeClass('form-modal_show');
        $('body').removeClass('noscroll');
      });
  }

  function initRegistrationLink() {
    $(selectors.openWinRegistration).on('click', function()
      {
        $('.win-registration-container').fadeIn();
        return false;
      });
  }
});

jQuery(function($) {
  //$("#menu-item-1975, #menu-item-1984").addClass("js-button-form-show");

  $( ".new-bam a, .new-nmr" ).click(function(e) {
    e.preventDefault();
    $('#js-form-modal').addClass('form-modal_show');
    $('body').addClass('noscroll');
  });

  $( "#menu-footer-menu, #menu-secondary-menu" ).on( "click", ".js-button-form-show a, a.js-button-form-show", function(e) {
    e.preventDefault();
    $('#js-form-modal').addClass('form-modal_show');
    $('body').addClass('noscroll');
  });

  window.addEventListener('WinReg:Destroy', function()
    {
      $('#js-form-modal').removeClass('form-modal_show');
      $('body').removeClass('noscroll');
    });
});

jQuery(function($) {
  $(document).ready(function() {
    postArchiveInit();
  });

  function postArchiveInit() {
    var $rows = $('.post-archive-row');

    $rows.each(function(i, elem) {
      postArchiveInstance($(elem));
    });

    function postArchiveInstance($row) {
      var $select = $row.find('select.post-archive-filters');
      var $posts  = $row.find('.post-archive_card');
      var $empty  = $row.find('.post-archive_empty-results');
      var $found  = null;
      var options = {
        duration: 500,
        easing: 'linear'
      };

      $select.change(callBack);

      if ($posts.length === 0) {
        $empty.show();
      }

      function callBack() {
        var isSelected = $select.attr('selected');
        var value      = $select.val();

        $posts.hide();
        $empty.hide();

        if (value === 'all' || value === '' || value === null) {
          if ($posts.length === 0) {
            $empty.show();
          }
          else {
            $posts.fadeIn(options);

            $select.find('option[value="none"]').removeAttr('selected');
            $select.find('option[value=""]').attr('selected', '');  
          }
        }
        else {
          $found = $posts.filter('[post-cats*="' + value + '"]');

          if ($found.length === 0) {
            $empty.fadeIn({
              duration: 200,
              easing: 'linear'
            });
          }
          else {
            $found.fadeIn(options);
          }
        }
      }
    }
  }
});

jQuery(function($) {

	initSiteSearch();

	function initSiteSearch() {
		$('.open-search').on('click', function() {
			var $content = $('.hidden-modal--search .search-form');

			setTimeout(function () {
				$.magnificPopup.open({
					removalDelay: 0,
					closeBtnInside: true,
					showCloseBtn: true,
					overflowY: 'scroll',
					mainClass: 'modal__wrapper',
					items: {
					src: $content
					},
					type: 'inline'
				});
			}, 100);

			return false;
		});
	}

});
